export default __webpack_public_path__ + "static/media/INCH.205ae40e.png";